<template>
  <div class="d-flex flex-wrap" :class="{
    'justify-content-center': templateClass === 'bmw',
  }">
  <template v-if="buttonSettings.length">
    <template v-for="(settingsdata, index) in buttonSettings">
      <a v-if="settingsdata?.isCTAButtonEnabled" :key="index"
        :href="settingsdata.ctaButtonType.toLowerCase() === 'custom url' ? settingsdata.customUrl : undefined"
        :target="settingsdata.tabType.toLowerCase() === 'same tab' ? '_self' : '_blank'"
        @click="ctaAction($event, settingsdata.ctaButtonType)" :class="btnClass"
        :aria-label="settingsdata.ctaButtonName || settingsdata.ctaButtonActualName">
        <small :class="btnLabel">
          {{ settingsdata.ctaButtonName || settingsdata.ctaButtonActualName }}
        </small>
      </a>
    </template>
    </template>
  </div>
</template>
<script>
import { mapState } from "pinia";
import { useRotationalSpecialBannersStore } from "../../store/RotationalSpecialBannersStore/RotationalSpecialBannersStore";
export default {
  props: {
    templateClass: {
      type: String,
      required: false,
    },
    paymentOffer: {
      type: Object,
      required: true,
    },
  },
   mounted(){
    const store = useRotationalSpecialBannersStore();
     store.fetchCTASettings();
  },
  computed: {
    ...mapState(useRotationalSpecialBannersStore, ["getButtons"]),
    buttonSettings() {
      return this.getButtons || [];
    },
    btnClass() {
      const baseClass = "cursor-pointer no-hover border-black-bottom color-black";
      if (this.templateClass === "paragon") {
        return `${baseClass} btn-websites button-link mx-2`;
      } else if (this.templateClass === "frame") {
        return `${baseClass} mx-2`;
      } else if (this.templateClass === "luxury") {
        return `${baseClass} btn-websites button-link mx-2`;
      } else if (this.templateClass === "bmw") {
        return `cursor-pointer no-hover bgcolor-primary text-white p-3 mr-2 text-center rounded-buttons d-block my-2`;
      }
      return "";
    },
    btnLabel() {
      const baseLabel = "color-black rotational-special-font-secondary-color";
      if (this.templateClass === "paragon") {
        return `${baseLabel} `;
      } else if (this.templateClass === "frame") {
        return `${baseLabel}`;
      } else if (this.templateClass === "luxury") {
        return `${baseLabel} `;
      } else if (this.templateClass === "bmw") {
        return "";
      }
      return "";
    },
  },
  methods: {
    ctaAction(event, ctaType) {
      if (ctaType.toLowerCase() !== 'custom url') {
        event?.preventDefault();
        this.$emit("cta-action", ctaType);
      }
    },
  },
};
</script>
